import { Component, OnInit } from '@angular/core';
import {ApiService, GoogleEvents} from '../../services/api.service';
import {RSLoadingModalService} from '../../../libs/rsloading/rsloading.service';
import {RSDialogService} from '../../../libs/rsnotify/rsdialog.service';
import {UserService} from '../../services/user.service';
import {DataService} from '../../services/data.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public emailAddress = '';
  public password = '';

  constructor(
      private apiServices: ApiService,
      private rsLoading: RSLoadingModalService,
      private rsDialog: RSDialogService,
      public userService: UserService,
      private router: Router
  ) {
    this.userService.activeUserState.subscribe(state => {
      console.log('User State: ', state);
      if (state) {
        this.router.navigate(['home']);
      }
    });
  }

  ngOnInit(): void {
    this.apiServices.logGoogleEvent(GoogleEvents.LoginPage);
  }

  public async loginUser() {
    this.rsLoading.show();
    try {
      const token = await this.apiServices.loginUser(this.emailAddress, this.password);
      await this.userService.signInWithToken(token); // Sign in! This should be moved to our account!!
    } catch (e) {
      console.error(e);
      this.rsDialog.showErrorDialog(e.message ? e.message : e);
    }
    this.rsLoading.hide();
  }

}
